<template>
  <div>
    <span class="font-12 font-weight-medium">Análise Sugestão</span>

    <div class="overflow-y-auto">
      <table id="tabela-entradas-futuras">
        <tr>
          <th v-for="cab in cabecalhos">{{ cab.text }}</th>
        </tr>

        <tr>
          <td v-for="cabecalho in cabecalhos">
            <template v-if="cabecalho.formatar">
              {{ cabecalho.converter_embalagem ? Helpers.formatarValor(converteEmbalagemValor(analise_entrada_sugestao[cabecalho.value])) : Helpers.formatarValor(analise_entrada_sugestao[cabecalho.value]) }}
            </template>

            <template v-else>{{ analise_entrada_sugestao[cabecalho.value] }}</template>

            <template v-if="cabecalho.apendar">{{ cabecalho.apendar }}</template>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AnaliseSugestao",
  props: {
    analise_entrada_sugestao: Object,
    dados_conversao: Object
  },
  data: () => ({
    cabecalhos: [
      { text: 'Dt. Últ. Entrada', value: 'data_ult_entrada' },
      { text: 'Saldo Futuro Últ. Entrada', value: 'saldo', formatar: true, converter_embalagem: true },
      { text: 'Dt. Final LT', value: 'data_previsao' },
      { text: 'Intervalo', value: 'dias_entre_entregas', formatar: true, apendar: 'dias', converter_embalagem: false },
      { text: 'Consumo Trânsito', value: 'consumo_transito', formatar: true, converter_embalagem: true },
      { text: 'Saldo Residual', value: 'saldo_residual', formatar: true, converter_embalagem: true },
      { text: 'Status', value: 'status_compra' },
      { text: 'Sugestão', value: 'qtde_sugestao', formatar: true, converter_embalagem: true },
      { text: 'Saldo Futuro', value: 'saldo_futuro', formatar: true, converter_embalagem: true },
    ],
  }),
  computed: {
    ...mapGetters({
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
    }),
  },
  methods: {
    converteEmbalagemValor(valor) {
      const multiplo_compra = this.dados_conversao.multiplo_compra || 1;

      if (this.dados_conversao.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiplo_compra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiplo_compra) : valor;
    },
  }
}
</script>

<style scoped>
#tabela-entradas-futuras {
  width: 100%;
  overflow-y: auto;
  border-collapse: collapse;
  font-size: 12px;
  color: #595959;
}
#tabela-entradas-futuras tr th {
  background: #e3efff;
}
#tabela-entradas-futuras tr th, tr td {
  border: 1px solid #e1dfdf;
  padding: 0 2px;
  text-align: center;
}
</style>
